/* eslint-disable no-console */

import { authApi } from "@/api/api";
import jwt_decode from "jwt-decode";

const initialState = {
  idx: null,
  email: null,
  token: null,
  tokenType: null,
  roles: null,
  memberType: null,
  tokenExpiry: null,
  isLoggedIn: false,
  showTokenExpiryAlert: false,
};

const authStore = {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    SET_STATE(state, { key, value }) {
      state[key] = value;
    },
    LOGOUT(state) {
      Object.assign(state, initialState);
    },
  },
  actions: {
    login({ commit, state }, { accessToken }) {
      const token = accessToken.access_token;
      const tokenType = accessToken.token_type;

      const payload = jwt_decode(token);

      commit("SET_STATE", { key: "token", value: token });
      commit("SET_STATE", { key: "tokenType", value: tokenType });

      if (payload) {
        commit("SET_STATE", { key: "idx", value: payload.idx });
        commit("SET_STATE", { key: "email", value: payload.email });
        commit("SET_STATE", { key: "roles", value: payload.admin_types });
        commit("SET_STATE", { key: "memberType", value: payload.member_type });

        commit("SET_STATE", { key: "tokenExpiry", value: payload.exp });
      }

      if (token) {
        commit("SET_STATE", { key: "isLoggedIn", value: true });
      }
      return true;
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    async refreshToken({ dispatch, state }) {
      try {
        const headers = {
          Authorization: `${state.tokenType} ${state.token}`,
        };
        const response = await authApi.refresh(headers);

        const accessToken = {
          access_token: response.data.access_token,
          token_type: response.data.token_type,
        };

        dispatch("login", { accessToken });
      } catch (error) {
        // console.error("토큰 갱신 실패:", error);
        throw error;
      }
    },
    initializeAuth({ dispatch, state }) {
      const now = Math.floor(Date.now() / 1000); // 현재 시간 (초 단위)
      const tokenExpiry = state.tokenExpiry;

      if (tokenExpiry && tokenExpiry > now) {
        const timeUntilAlert = (tokenExpiry - now - 300) * 1000; // 5분 전 알림

        if (timeUntilAlert > 0) {
          setTimeout(() => {
            dispatch("notifyTokenExpiry");
          }, timeUntilAlert);
        } else if (timeUntilAlert <= 0 && tokenExpiry > now) {
          // 즉시 알림
          dispatch("notifyTokenExpiry");
        }

        const timeUntilLogout = (tokenExpiry - now) * 1000; // 만료 시간 로그아웃
        setTimeout(() => {
          dispatch("logout");
        }, timeUntilLogout);
      } else {
        dispatch("logout");
      }
    },
    notifyTokenExpiry({ commit, dispatch }) {
      const userConfirmed = window.confirm(
        "곧 로그인 세션이 만료됩니다. 갱신하시겠습니까?"
      );
      if (userConfirmed) {
        dispatch("confirmTokenRefresh");
      } else {
        dispatch("logout");
      }
    },
    confirmTokenRefresh({ dispatch, commit }) {
      commit("SET_STATE", { key: "showTokenExpiryAlert", value: false });
      dispatch("refreshToken");
    },
  },
  getters: {
    userId: (state) => state.idx,
    userEmail: (state) => state.email,
    authToken: (state) => state.token,
    tokenType: (state) => state.tokenType,
    userRoles: (state) => state.roles,
    userType: (state) => state.memberType,
    tokenExpiry: (state) => state.tokenExpiry,
    isLoggedIn: (state) => state.isLoggedIn,
  },
};

export default authStore;
